module.exports = __webpack_public_path__ + "img/8.89bdc059.png";